"use client"

import Error from "next/error"
import { useEffect } from "react"
import { useLogger, LogLevel } from "next-axiom"
import { usePathname } from "next/navigation"

export default function GlobalError({ error }) {
  const log = useLogger({ source: "global-error.jsx" })
  const pathname = usePathname()

  useEffect(() => {
    log.error(error)
  }, [error])

  let status = error.message == "Invalid URL" ? 404 : 500

  log.logHttpRequest(
    LogLevel.error,
    error.message,
    {
      host: window.location.href,
      path: pathname,
      statusCode: status,
    },
    {
      error: error.name,
      cause: error.cause,
      stack: error.stack,
      digest: error.digest,
    },
  )

  return (
    <html>
      <body>
        <Error />
      </body>
    </html>
  )
}
